import { useState } from "react";
import logo from "../images/lt.png";
import { getActiveUser, setActiveUser } from "../services/authLock";
import { authAPI } from "../services/api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [takeoverPrompt, setTakeoverPrompt] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setTakeoverPrompt(false);

    try {
      const res = await authAPI.login(username, password);
      console.log("Login result:", res.data);

      if (res.data.success) {
        sessionStorage.setItem("auth", "true");
        setActiveUser(username);
        onLogin();
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 401) {
          setError("Invalid username or password");
        } else if (err.response.status === 409) {
          // Someone is already logged in
          setTakeoverPrompt(true);
        } else {
          setError("Login failed. Try again.");
        }
      } else {
        setError("Network error. Please try later.");
      }
    }
  };

  const confirmTakeover = async () => {
    try {
      const res = await authAPI.login(username, password, true); // send takeover flag
      if (res.data.success) {
        sessionStorage.setItem("auth", "true");
        setActiveUser(username);
        onLogin();
      }
    } catch (err) {
      setError("Takeover failed. Try again.");
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-xl shadow-lg w-80"
      >
        <img src={logo} className="mb-4" alt="Logo" />
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          className="border p-2 w-full rounded mb-2"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="border p-2 w-full rounded mb-2"
        />
        {error && <p className="text-red-500 text-sm">{error}</p>}

        {takeoverPrompt && (
          <div className="text-sm text-orange-600 mb-2">
            Another user is already logged in.
            <br />
            <button
              type="button"
              className="bg-orange-500 text-white px-3 py-1 rounded mt-2"
              onClick={confirmTakeover}
            >
              Take Over
            </button>
          </div>
        )}

        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded w-full"
        >
          Login
        </button>
      </form>
    </div>
  );
}
